import SignoutCallback from './signout-callback';

const SignoutCallbackConfig = {
  settings: {
    layout: {
      style: 'layoutFull',
      config: {}
    }
  },
  routes: [
    {
      path: '/signout',
      component: SignoutCallback,
      title: 'Çıkış yapılıyor...'
    }
  ]
};

export default SignoutCallbackConfig;
